import script from "./SendApplyAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendApplyAdd.vue?vue&type=script&lang=ts&setup=true"

import "./SendApplyAdd.vue?vue&type=style&index=0&id=0b203f1c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b203f1c"]])

export default __exports__